// import { Icon } from "@iconify/react";
// import React from "react";

// import { ApplyForJob, FindTalent } from "@/components";

// const YouBelongHere = () => {
//   return (
//     <section className="max-w-screen-2xl mx-auto lg:px-28 px-6 py-12">
//       <div className="text-[32px] font-medium leading-10 tracking-[-0.16px] text-black dark:text-foreground-950 mb-4 max-w-lg">
//         Whether you’re hiring or building your career, you belong here.
//       </div>

//       <div className="text-foreground-600 dark:text-foreground-600 font-normal text-base leading-6 tracking-[-0.176px] mb-10 max-w-3xl pr-5">
//         Whether you’re an employer looking to strengthen your team or a
//         professional ready for your next opportunity, Cotton Recruiting is built
//         to help you grow and build with purpose.
//       </div>

//       <div className="grid grid-cols-2 gap-2">
//         <div className="p-4 rounded-2xl bg-[#F8FAFB] dark:bg-foreground-50 border-[0.5px] border-foreground-200 dark:border-foreground-200">
//           <div className="inline-flex p-[5.14px] rounded-[10.286px] border-[0.643px] text-primary-600 dark:text-primary border-foreground-200 dark:border-foreground-200 mb-10 bg-white dark:bg-foreground-100">
//             <Icon icon="ri:building-fill" />
//           </div>

//           <div className="text-foreground dark:text-foreground-950 text-lg font-medium leading-6 tacking-[-0.27px] mb-3">
//             For Employers
//           </div>

//           <div className="text-foreground-700 dark:text-foreground-600 font-normal text-sm leading-5 tracking-[-0.084px] mb-3">
//             Find talents from around the world and across all skills{" "}
//           </div>

//           <FindTalent label="Hire a cotton vetted talent" fullWidth={false} />
//         </div>

//         <div className="p-4 rounded-2xl bg-[#F8FAFB] dark:bg-foreground-50 border-[0.5px] border-foreground-200 dark:border-foreground-200">
//           <div className="inline-flex p-[5.14px] rounded-[10.286px] border-[0.643px] text-primary-600 dark:text-primary border-foreground-200 dark:border-foreground-200 mb-10 bg-white dark:bg-foreground-100">
//             <Icon icon="ri:user-2-fill" />
//           </div>

//           <div className="text-foreground dark:text-foreground-950 text-lg font-medium leading-6 tacking-[-0.27px] mb-3">
//             For Employers
//           </div>

//           <div className="text-foreground-700 dark:text-foreground-600 font-normal text-sm leading-5 tracking-[-0.084px] mb-3">
//             Find talents from around the world and across all skills{" "}
//           </div>

//           <ApplyForJob
//             className="border-0 bg-primary text-white dark:bg-primary dark:text-background"
//             label="Find your next job opportunity"
//             fullWidth={false}
//           />
//         </div>
//       </div>
//     </section>
//   );
// };

// export default YouBelongHere;

import { Icon } from "@iconify/react";
import React from "react";

import { ApplyForJob, FindTalent } from "@/components";

const YouBelongHere = () => {
  return (
    <section className="max-w-screen-2xl mx-auto lg:px-28 px-4 sm:px-6 py-10 sm:py-12">
      <div
        className="text-[24px] sm:text-[28px] md:text-[32px] font-medium leading-8 sm:leading-9 md:leading-10 tracking-[-0.16px] text-black dark:text-foreground-950 mb-4 max-w-lg text-center md:text-left mx-auto md:mx-0"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        Whether you’re hiring or building your career, you belong here.
      </div>

      <div
        className="text-foreground-600 dark:text-foreground-600 font-normal text-sm sm:text-base leading-5 sm:leading-6 tracking-[-0.176px] mb-8 sm:mb-10 max-w-3xl pr-0 md:pr-5 text-center md:text-left mx-auto md:mx-0"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        Whether you’re an employer looking to strengthen your team or a
        professional ready for your next opportunity, Cotton Recruiting is built
        to help you grow and build with purpose.
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-2">
        {/* Employer Card */}
        <div
          className="p-4 rounded-2xl bg-[#F8FAFB] dark:bg-foreground-50 border-[0.5px] border-foreground-200 dark:border-foreground-200"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <div className="inline-flex p-[5.14px] rounded-[10.286px] border-[0.643px] text-primary-600 dark:text-primary border-foreground-200 dark:border-foreground-200 mb-6 sm:mb-10 bg-white dark:bg-foreground-100">
            <Icon icon="ri:building-fill" />
          </div>

          <div className="text-foreground dark:text-foreground-950 text-base sm:text-lg font-medium leading-6 tracking-[-0.27px] mb-3">
            For Employers
          </div>

          <div className="text-foreground-700 dark:text-foreground-600 font-normal text-sm leading-5 tracking-[-0.084px] mb-3">
            Find talents from around the world and across all skills
          </div>

          <FindTalent fullWidth={false} label="Hire a cotton-vetted talent" />
        </div>

        {/* Talent Card */}
        <div
          className="p-4 rounded-2xl bg-[#F8FAFB] dark:bg-foreground-50 border-[0.5px] border-foreground-200 dark:border-foreground-200"
          data-aos="fade-up"
          data-aos-delay="400"
        >
          <div className="inline-flex p-[5.14px] rounded-[10.286px] border-[0.643px] text-primary-600 dark:text-primary border-foreground-200 dark:border-foreground-200 mb-6 sm:mb-10 bg-white dark:bg-foreground-100">
            <Icon icon="ri:user-2-fill" />
          </div>

          <div className="text-foreground dark:text-foreground-950 text-base sm:text-lg font-medium leading-6 tracking-[-0.27px] mb-3">
            For Employers
          </div>

          <div className="text-foreground-700 dark:text-foreground-600 font-normal text-sm leading-5 tracking-[-0.084px] mb-3">
            Find talents from around the world and across all skills
          </div>

          <ApplyForJob
            className="border-0 bg-primary text-white dark:bg-primary dark:text-background"
            fullWidth={false}
            label="Find your next job opportunity"
          />
        </div>
      </div>
    </section>
  );
};

export default YouBelongHere;
